
import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependency'
import { TemplateNotificationBannerStyles } from './NotificationBanner.styles'

const t = document.createElement('template')
t.innerHTML = `

<wa-callout exportparts="variant,appearance">
<div class="wa-split">
<wa-icon name="circle-info"></wa-icon><slot></slot>
<wa-button>x</wa-button>
  
</div>
</wa-callout>
`

class NotificationBanner extends HTMLElement {
  private waCallout: HTMLElement | null = null

  constructor() {

    
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Callout, WebAwesomeComponent.Button])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(TemplateNotificationBannerStyles.content.cloneNode(true))
  
    shadow.appendChild(t.content.cloneNode(true))

    this.waCallout = shadow.querySelector('wa-callout')
  }
static get observedAttributes() {
    return ['variant']
  }
  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (name === 'variant') {
      console.log('Pagination attributeChangedCallback', this.waCallout)

      this.waCallout?.setAttribute("variant", newValue);
    }
  }
  connectedCallback() {
    // Forward all attributes to wa-details
    if (this.waCallout) {
      for (const attr of this.attributes) {
        this.waCallout.setAttribute(attr.name, attr.value)
      }

    }

  }
}

customElements.define('ts-notificationbanner', NotificationBanner)
